import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class ServicePriceID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
